<template>
    <table class="table table-bordered table-striped table-vcenter dataTable">
        <thead>
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Created at</th>
                <th></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
export default {
    props: {
        ajaxUrl: String,
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[2, 'desc']],
            columns: [
                {
                    data: 'name',
                },
                {
                    data: 'email',
                },
                {
                    data: 'created_at',
                },
                {
                    data: 'actions',
                },
            ]
        });
    }
}
</script>
